import { xyz_n_1of4 } from './SL00000Sprint00TTR'

import { sprintPlanningExpectations } from './SL44000Sprint05TTR'

import { list20000Sprint05 } from '../ActivityLists/AL20000Sprint05'
import { list20000Sprint06 } from '../ActivityLists/AL20000Sprint06'

import { checklistAnnouncementsPreworkAndAgenda } from './SL00000Sprint00'
import { completeDeck } from './SL00000Sprint00'
import { tRecap } from './SLSprint00'	
import { tPrework } from './SLSprint00'

import { submissionPercentage } from './SLSprint00'
import { orderedListSlide } from './SLSprint00'
import { xyz_n_DemosAndRetrospective } from './SL00000Sprint00TTR'

import { xyz_n_1of4_PAaA, xyz_n_4of4_PAaA, xyz_n_4of4 } from './SL00000Sprint00TTR'

// Introduction to Computer Science (ICS) sprint 6 global values.
const sprint = 6
const activityList = () => { return list20000Sprint06(sprint) }
const activityListPrevious = () => { return list20000Sprint05(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const ics_6_1of4 = () => { return xyz_n_1of4(null, null, sprintAndActivityLists, sprintPlanningExpectations) }

const ics_6_2of4_PAaA = {
	'prework':[
		'Complete through activity 8 prior to next class', '',
		`Be prepared sprint ${sprint-1} Demos and Retrospectives` ],
	'announcements':[ 
		'Any announcements for the class?' ],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		'Prework for Next Class' ]
}

const ics_6_2of4 = () => { 
	const preworkNext = () => { return tPrework('Prework For Next Class', ics_6_3of4_PAaA.prework, sprint, activityList) }
	const recap = () => { return tRecap(ics_6_2of4_PAaA.agenda) }

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(ics_6_2of4_PAaA, sprint, activityList)
	return completeDeck(slideDeck, [ preworkNext, recap ])
}

const ics_6_3of4_PAaA = {
	'prework':[
		'Complete through activity 10 prior to next class', '',
		`Be prepared sprint ${sprint-1} Demos and Retrospectives` ],
	'announcements':[ 
		'Any announcements for the class?' ],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		'Prework for Next Class',
		'Lab',
		`Quiz ${sprint}` ]
}

const ics_6_3of4 = () => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:24, submitted:19 },
			{ name: 'Quiz', due:24, submitted:22 },
			{ name: 'Lab', due:24, submitted:20 },
			{ name: 'Reflection', due:24, submitted:20 }])
	}
	const retrospective = () => {
			return orderedListSlide('Class Retrospective',
				'Feedback from Assignments & Reflections', [
				`Incredible submission percentage in sprint ${sprint-1}`,
				`All sprint ${sprint-1} assignments were submitted by all students in the class`, 
				'We were missing one Lab 1 - Planning submission, but I am going to let that slide (never done that before)',
				'How would we like to celebrate... my daughter is certain that we need “Tessi Day”' ])
	}	

	return xyz_n_DemosAndRetrospective(ics_6_3of4_PAaA, ics_6_4of4_PAaA, sprintAndActivityLists, metricsSubmissionPercentage, retrospective)
}

export const ics_6_4of4_PAaA = xyz_n_4of4_PAaA(11, sprint)

const ics_6_4of4 = () => { 
	return xyz_n_4of4(ics_6_4of4_PAaA, xyz_n_1of4_PAaA(sprint+1), sprintAndActivityLists ) 
}

export const ics_6_slidedeckTTR = [ ics_6_1of4, ics_6_2of4, ics_6_3of4, ics_6_4of4 ]